import { gql } from '@apollo/client';
import { mutate, query } from '../apollo/ApolloClient';

interface AlarmPolicy {
  id: number;
  name: string;
  channelName: string;
  policy: Policy;
}

interface Policy {
  numberOfAnomalies: number;
  windowSize: string;
}

interface UpdateAlarmPolicyResponse {
  updateAlarmPolicy: AlarmPolicy;
}

export interface UpdateAlarmPolicyRequest {
  id: number;
  name: string;
  numberOfAnomalies: number;
  windowSize: string;
}

const ALARM_POLICIES_QUERY = gql`
  query alarmPolicies {
    alarmPolicies {
      id
      name
      policy {
        numberOfAnomalies
        windowSize
      }
      channelName
    }
  }
`;

const UPDATE_ALARM_POLICY_MUTATION = gql`
  mutation updateAlarmPolicy($id: Int32!, $name: String!, $numberOfAnomalies: Int32!, $windowSize: String!) {
    updateAlarmPolicy(id: $id, name: $name, numberOfAnomalies: $numberOfAnomalies, windowSize: $windowSize) {
      id
      name
      policy {
        numberOfAnomalies
        windowSize
      }
      channelName
    }
  }
`;

interface QueryAlarmPoliciesResponse {
  alarmPolicies: AlarmPolicy[];
}

export const queryAlarmPolicies = async (): Promise<QueryAlarmPoliciesResponse | null | undefined> => {
  const data = await query<QueryAlarmPoliciesResponse>({
    query: ALARM_POLICIES_QUERY,
    fetchPolicy: 'network-only',
  });
  return data;
};

export const updateAlarmPolicy = async (
  updateAlarmPolicyRequest: UpdateAlarmPolicyRequest
): Promise<UpdateAlarmPolicyResponse | null | undefined> => {
  const data = await mutate<UpdateAlarmPolicyResponse, UpdateAlarmPolicyRequest>({
    mutation: UPDATE_ALARM_POLICY_MUTATION,
    variables: updateAlarmPolicyRequest,
  });
  return data;
};
